import React from 'react';
import type { ImageBlock } from '../../store/chatStore';
import { MessageFileItem } from './MessageFileItem';

interface ImageContentProps {
  content: ImageBlock;
}

const getNameFromUrl = (urlString: string): string => {
  try {
    const url = new URL(urlString);
    const pathname = url.pathname;
    const lastSegment = pathname.split('/').filter(Boolean).pop() || '';
    return decodeURIComponent(lastSegment || 'image');
  } catch {
    return 'image';
  }
};

export const ImageContent: React.FC<ImageContentProps> = ({ content }) => {
  const imageSrc =
    content.source.type === 'base64'
      ? `data:${content.source.media_type};base64,${content.source.data}`
      : content.source.url;

  const fileName =
    content.source.type === 'url'
      ? getNameFromUrl(content.source.url)
      : `image.${(content.source.media_type || 'png').split('/').pop()}`;

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = imageSrc;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <MessageFileItem
      fileName={fileName}
      mimeType={content.source.media_type}
      previewUrl={imageSrc}
      onDownload={handleDownload}
      showDownload={false}
    />
  );
};
